<template lang="pug">
div.project-list-container
  div.project-list
    div.project-item(v-for="project in projectList" :key="project.id" :class="{active: value && value.id === project.id}"
    @click="handleClick(project)"
    )
      span.p1.px2 {{ project.name }}
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: Object,
  },
  data() {
    return {
      projectList: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.$restful(`GET:/sys/projects/list`)
        .then((res) => {
          this.projectList = res?.filter((item) => item.code !== 'hq');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClick(prj) {
      // console.log(prj);
      this.$emit('change', prj);
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';
.project-list-container {
  width: 240px;
  height: 100%;
  .project-list {
    .project-item {
      display: flex;
      height: 40px;
      align-items: center;
      cursor: pointer;
      &:hover {
        background-color: fadeout(@primary-color, 80%);
      }
      &.active {
        color: #fff;
        background-color: @primary-color;
      }
    }
  }
}
</style>
